import { render } from "./CheckBoxGroup.vue?vue&type=template&id=23e569c0&ts=true"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__